// Lightweight device / install detection for notification onboarding.

export function isStandalone() {
  try {
    return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
  } catch {
    return false;
  }
}

export function getPlatform() {
  const ua = navigator.userAgent || "";
  // iPadOS 13+ reports as Mac; detect via touch points.
  if (/iPad|iPhone|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) return "ios";
  if (/Android/.test(ua)) return "android";
  return "desktop";
}

export function iosVersion() {
  const m = (navigator.userAgent || "").match(/OS (\d+)_(\d+)/);
  return m ? [parseInt(m[1], 10), parseInt(m[2], 10)] : null;
}

// Web Push on iOS/iPadOS requires 16.4+ AND an installed (Home Screen) web app.
export function iosPushCapable() {
  const v = iosVersion();
  if (!v) return true; // unknown version — don't hard-block
  return v[0] > 16 || (v[0] === 16 && v[1] >= 4);
}

export function getBrowser() {
  const ua = navigator.userAgent || "";
  if (/SamsungBrowser/.test(ua)) return "samsung";
  if (/Edg/.test(ua)) return "edge";
  if (/OPR|Opera/.test(ua)) return "opera";
  if (/Firefox|FxiOS/.test(ua)) return "firefox";
  if (/CriOS|Chrome/.test(ua)) return "chrome";
  if (/Safari/.test(ua)) return "safari";
  return "other";
}
